// BFF: ○ gap — legacy userPeopleSearch. Member search has no bff/crm module.
export { default as PeopleSearch } from './PeopleSearch'
export { default as PersonInstantNav } from './PersonInstantNav'
